export interface IListTreatmentsEndpointQuery {
  medical_specialty_id?: string;
  sort?: string;
  treatment_category_id?: string;
}

export interface IListTreatmentsEndpointResponse {
  list: {
    id: string;
    is_available_website: boolean;
    is_favorite: boolean;
    title: string;
  }[];
}

export const listTreatmentsEndpoint = () => '/treatments';
